import Vue from 'vue';
import FastSync from './fast-sync';
import CrmSync from './crm-sync';
import ApiService from '../services/api.service';

const factories = {
  fastSync: FastSync(ApiService),
  crmSync: CrmSync(ApiService),
};

Vue.prototype.$api = factories;
